export default __webpack_public_path__ + "src/assets/credits-coingecko.2eb3562ef376a633ec118ad6a3798826.svg";